import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ArchiveArchiveIndexSet } from "@graylog/enterprise-api";
import i18n from "i18n";
import UserNotification from "util/UserNotification";
import { ARCHIVE_INDEX_SET_CONFIGURATION_QUERY_KEY } from "archive/hooks/useArchiveIndexSetConfiguration";
const updateConfiguration = async (newConfiguration) => ArchiveArchiveIndexSet.updateIndexSetConfig(newConfiguration);
const useArchiveIndexSetConfigurationMutation = () => {
  const queryClient = useQueryClient();
  const update = useMutation({
    mutationFn: updateConfiguration,
    onError: (errorThrown) => {
      UserNotification.error(
        i18n.t("notifications.index_set_config_failed", { ns: "enterprise_archive", error: errorThrown }),
        i18n.t("notifications.index_set_config_failed_title", { ns: "enterprise_archive" })
      );
    },
    onSuccess: () => {
      UserNotification.success(
        i18n.t("notifications.index_set_config_success", { ns: "enterprise_archive" }),
        i18n.t("notifications.success_title", { ns: "enterprise_archive" })
      );
      queryClient.refetchQueries({ queryKey: [ARCHIVE_INDEX_SET_CONFIGURATION_QUERY_KEY], type: "active" });
    }
  });
  return {
    updateArchiveIndexSetConfigurationMutation: update.mutateAsync
  };
};
export default useArchiveIndexSetConfigurationMutation;
